import { create, w } from '@dojo/framework/core/vdom';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Chart } from 'chart.js';

import { ChartBase, ChartProperties } from '@holmescorp/charts';

const factory = create({}).properties<ChartProperties>();

export const ScatterChart = factory(({ properties }) => {
	const {
		ariaLabel = 'scatter chart',
		size,
		data,
		drawComplete,
		legend,
		options,
		plugins,
		pluginCode,
		title,
		alternateText
	} = properties();
	const type = 'scatter';

	return w(ChartBase, {
		ariaLabel,
		alternateText,
		size,
		data,
		drawComplete,
		legend,
		options,
		plugins,
		pluginCode,
		title,
		type
	});
});
